export const BATCH_DELAY = 200;
export const BASE_DELAY = 1000;
export const MAX_RETRIES = 3;
export const MAX_DELAY = 32000;
